import React, { useState } from 'react';

import { Box, Button, CircularProgress, Input, InputBase, TextField, Typography } from '@mui/material';
import { get, upperCase } from 'lodash';
import { toast } from 'react-toastify';

import AxlDialog from 'components/AxlDialog';
import { updateDetectionRequest } from 'repositories/HttpRepository';
import { FIELD_NAME } from '.';
import { Label } from '@mui/icons-material';

function Confirm({ isOpen, onClose, clientId, clientName, onConfirm }) {
  const [isConfirming, setIsConfirming] = useState(false);
  const [confirmWords, setConfirmWords] = useState('');

  const correctConfirmWords = `REDACT_${clientId}`;

  const handleConfirm = () => {
    setIsConfirming(true);
    onConfirm();
  };

  const disableConfirmBtn = confirmWords.toLowerCase() !== correctConfirmWords.toLowerCase() || !clientId || isConfirming;

  return (
    <AxlDialog
      isOpen={isOpen}
      handleClose={isConfirming ? null : () => onClose()}
      maxWidth="sm"
      childrenTitle={'CONFIRMATION'}
      childrenAction={
        <Box style={{ gap: 8 }} sx={{ display: 'flex' }}>
          <Button variant="outlined" color="secondary" onClick={() => onClose()} size="small" disabled={isConfirming}>
            Cancel
          </Button>
          <Button disabled={disableConfirmBtn} variant="contained" onClick={handleConfirm} size="small">
            {isConfirming ? <CircularProgress size={20} /> : 'Confirm'}
          </Button>
        </Box>
      }
    >
      <Box>
        <Typography sx={{ mb: 2 }}>
          <strong>{clientName}</strong> customer contacts and their address will be permanently removed from our platform. This action cannot be undone.
        </Typography>
        <Box>
          <Typography>
            Type <strong style={{ marginBottom: '5px', display: 'inline-block' }}>REDACT_{clientId}</strong> to confirm
          </Typography>
          <TextField id="confirm-words" variant="outlined" fullWidth size="small" onChange={(e) => setConfirmWords(e.target.value)} onPaste={(e) => e.preventDefault()} />
        </Box>
      </Box>
    </AxlDialog>
  );
}

export default Confirm;
